import MuiFormGroup from "@mui/material/FormGroup";

const FormGroup = MuiFormGroup;

export default FormGroup;
